<template>
  <WCImage imageClass="barcode" :imageSrc="src" :imageAlt="alt" :defaultImage="false" />
</template>

<script>
import WCImage from '@/components/WCImage/WCImage.vue';

export default {
  components: { WCImage },
  props: {
    data: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      format: 'c128',
      dimensions: {},
      alt: this.$t('barcodeAltText'),
    };
  },
  computed: {
    src() {
      return `${this.$configuration.cdn}/api/img/${this.format}/${this.data}`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/tools';
@import '~@/assets/styles/settings';

.barcode {
  display: block;
  max-width: rem(350px);
  margin: 0 auto;
}
</style>
